// Machine-draft, non-clinical Journey presentation only. Do not add
// preparation questions, medication/fasting advice, legal notices or
// Trust-authored patient information to this pack.
const KEYS = Object.freeze(['ui.people.showFewer','ui.people.showAllCount','ui.trustLogoAlt']);
const DRAFTS = Object.freeze({
  "ar": [
    "عرض أدوار أقل",
    "عرض كل الأدوار وعددها {{count}}",
    "شعار {{trust}}"
  ],
  "bn": [
    "কম ভূমিকা দেখান",
    "সব {{count}}টি ভূমিকা দেখান",
    "{{trust}}-এর লোগো"
  ],
  "es": [
    "Mostrar menos roles",
    "Mostrar los {{count}} roles",
    "Logotipo de {{trust}}"
  ],
  "fa": [
    "نمایش نقش‌های کمتر",
    "نمایش همهٔ {{count}} نقش",
    "نشان‌وارهٔ {{trust}}"
  ],
  "fr": [
    "Afficher moins de rôles",
    "Afficher les {{count}} rôles",
    "Logo de {{trust}}"
  ],
  "gu": [
    "ઓછી ભૂમિકાઓ બતાવો",
    "બધી {{count}} ભૂમિકાઓ બતાવો",
    "{{trust}}નો લોગો"
  ],
  "it": [
    "Mostra meno ruoli",
    "Mostra tutti i {{count}} ruoli",
    "Logo di {{trust}}"
  ],
  "pa": [
    "ਘੱਟ ਭੂਮਿਕਾਵਾਂ ਦਿਖਾਓ",
    "ਸਾਰੀਆਂ {{count}} ਭੂਮਿਕਾਵਾਂ ਦਿਖਾਓ",
    "{{trust}} ਦਾ ਲੋਗੋ"
  ],
  "pl": [
    "Pokaż mniej ról",
    "Pokaż wszystkie {{count}} role",
    "Logo {{trust}}"
  ],
  "pt": [
    "Mostrar menos funções",
    "Mostrar todas as {{count}} funções",
    "Logótipo de {{trust}}"
  ],
  "ro": [
    "Arată mai puține roluri",
    "Arată toate cele {{count}} roluri",
    "Sigla {{trust}}"
  ],
  "so": [
    "Muuji doorar ka yar",
    "Muuji dhammaan {{count}} door",
    "Astaanta {{trust}}"
  ],
  "tl": [
    "Magpakita ng mas kaunting tungkulin",
    "Ipakita ang lahat ng {{count}} tungkulin",
    "Logo ng {{trust}}"
  ],
  "tr": [
    "Daha az rol göster",
    "{{count}} rolün tümünü göster",
    "{{trust}} logosu"
  ],
  "ur": [
    "کم کردار دکھائیں",
    "تمام {{count}} کردار دکھائیں",
    "{{trust}} کا لوگو"
  ],
  "zh": [
    "显示更少岗位",
    "显示全部{{count}}个岗位",
    "{{trust}}标志"
  ]
});
const code = language => String(language || '').toLowerCase().split('-')[0];
export const JOURNEY_PRESENTATION_DRAFT_LOCALES = Object.freeze(Object.keys(DRAFTS).sort());
export const JOURNEY_PRESENTATION_DRAFT_KEYS = KEYS;
export function journeyPresentationDraftFor(language, path) {
  const index = KEYS.indexOf(path);
  return index < 0 ? undefined : DRAFTS[code(language)]?.[index];
}
export function installJourneyPresentationDrafts(i18n, language, namespace) {
  if (namespace !== 'hospitalJourney') return;
  const locale = code(language);
  const strings = DRAFTS[locale];
  if (!strings) return;
  KEYS.forEach((path, index) => {
    const existing = i18n.getResource(locale, namespace, path);
    if (typeof existing !== 'string' || !existing.trim())
      i18n.addResource(locale, namespace, path, strings[index]);
  });
}
